export default __webpack_public_path__ + "static/images/indepth-charting.ad388a03.png";